<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Winter Blessings</title>
<link href="../styles/9780310354369_template.css" rel="stylesheet" type="text/css"/>
<p class="head1"><span class="right_1" epub:type="pagebreak" id="page_xi" title="xi">C<span class="small">ONTENTS</span></span></p>
<nav epub:type="toc" id="toc">
<ol>
<li class="toc" epub:type="frontmatter" style="text-indent:0em; margin-top:0em;"><span href="#/text/9780310354369_Copyright#copy" id="rcopy" title="Link target outside of Sample">C<span class="small">OPYRIGHT</span></span></li>
<li><a hidden="hidden" href="#/text/nav"><span class="hide1">C<span class="small">ONTENTS</span></span></a></li>
<li class="toc" epub:type="bodymatter" style="text-indent:0em; margin-top:1em;"><a href="#/text/9780310354369_Glossary_P4#P4_1" id="rP4_1">G<span class="small">LOSSARY</span></a></li>
<li class="toc" epub:type="bodymatter" style="text-indent:0em; margin-top:0em;"><a href="#/text/9780310354369_Ftree_P4#P4_2" id="rP4_2">F<span class="small">AMILY</span> T<span class="small">REE</span></a></li>
<li class="toc" epub:type="bodymatter" style="text-indent:0em; margin-top:0em;"><a href="#/text/9780310354369_Chapter1_P4#P4_3" id="rP4_3">C<span class="small">HAPTER</span> 1</a></li>
<li class="toc" epub:type="bodymatter" style="text-indent:0em; margin-top:0em;"><span href="#/text/9780310354369_Chapter2_P4#P4_4" id="rP4_4" title="Link target outside of Sample">C<span class="small">HAPTER</span> 2</span></li>
<li class="toc" epub:type="bodymatter" style="text-indent:0em; margin-top:0em;"><span href="#/text/9780310354369_Chapter3_P4#P4_5" id="rP4_5" title="Link target outside of Sample">C<span class="small">HAPTER</span> 3</span></li>
<li class="toc" epub:type="bodymatter" style="text-indent:0em; margin-top:0em;"><span href="#/text/9780310354369_Chapter4_P4#P4_6" id="rP4_6" title="Link target outside of Sample">C<span class="small">HAPTER</span> 4</span></li>
<li class="toc" epub:type="bodymatter" style="text-indent:0em; margin-top:0em;"><span href="#/text/9780310354369_Chapter5_P4#P4_7" id="rP4_7" title="Link target outside of Sample">C<span class="small">HAPTER</span> 5</span></li>
<li class="toc" epub:type="bodymatter" style="text-indent:0em; margin-top:0em;"><span href="#/text/9780310354369_Chapter6_P4#P4_8" id="rP4_8" title="Link target outside of Sample">C<span class="small">HAPTER</span> 6</span></li>
<li class="toc" epub:type="bodymatter" style="text-indent:0em; margin-top:0em;"><span href="#/text/9780310354369_Chapter7_P4#P4_9" id="rP4_9" title="Link target outside of Sample">C<span class="small">HAPTER</span> 7</span></li>
<li class="toc" epub:type="bodymatter" style="text-indent:0em; margin-top:0em;"><span href="#/text/9780310354369_Chapter8_P4#P4_10" id="rP4_10" title="Link target outside of Sample">C<span class="small">HAPTER</span> 8</span></li>
<li class="toc" epub:type="bodymatter" style="text-indent:0em; margin-top:0em;"><span href="#/text/9780310354369_Questions_P4#P4_11" id="rP4_11" title="Link target outside of Sample">D<span class="small">ISCUSSION</span> Q<span class="small">UESTIONS</span></span></li>
<li class="toc" epub:type="bodymatter" style="text-indent:0em; margin-top:0em;"><span href="#/text/9780310354369_Acknowledgments_P4#P4_12" id="rP4_12" title="Link target outside of Sample">A<span class="small">CKNOWLEDGMENTS</span></span></li>
<li class="toc" epub:type="bodymatter" style="margin-top:1em;"><span href="#/text/About_the_Author#Author_13" id="rAuthor_13" title="Link target outside of Sample">A<span class="small">BOUT THE</span> A<span class="small">UTHOR</span></span></li>
</ol>
</nav>
<div class="hide1">
<nav epub:type="landmarks" hidden="">
<h1 class="toc">Guide</h1>
<ol>
<li><span epub:type="cover" href="#/text/9780310354369_Cover" title="Link target outside of Sample">Cover</span></li>
<li><a epub:type="toc" href="#/text/nav">Contents</a></li>
<li><a epub:type="bodymatter" href="#/text/9780310354369_Chapter1_P4">C<span class="small">HAPTER</span> 1</a></li>
</ol>
</nav>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?d2cbb38a